module.exports = require("./dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// jquery (bower component)
// module id = 1
// module chunks = 0 1